import { useEffect } from 'react';
import en from '../../lang/en-us';
import SuccessScreen from './makeNct/SuccessScreen';

const { updateSecurityQuestion } = en;

export default function UpdateSecurityQuestionsSuccess(props: any) {
    return (
        <div className="curved-bg">
            <SuccessScreen
                heading={updateSecurityQuestion.success.heading}
                backLink="profile"
                successMessage={updateSecurityQuestion.successMessage}
                handleClick={() => props.history.push('/portal/track')}
                backNavigation={() => props.history.push('/portal/profile')}
                showTrackStatusButton={false}
            />
        </div>
    );
}
